import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const BookOpenFill: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
    >
      <path
        d="M13.9999 14H8.66658V4C8.66658 2.89543 9.56199 2 10.6666 2H13.9999C14.3681 2 14.6666 2.29848 14.6666 2.66667V13.3333C14.6666 13.7015 14.3681 14 13.9999 14ZM7.33325 14H1.99992C1.63173 14 1.33325 13.7015 1.33325 13.3333V2.66667C1.33325 2.29848 1.63173 2 1.99992 2H5.33325C6.43782 2 7.33325 2.89543 7.33325 4V14ZM7.33325 14H8.66658V15.3333H7.33325V14Z"
        fill={color}
      />
    </svg>
  );
};

export default BookOpenFill;
